import React from 'react';
import BaseToggleView from '../..';
import "./styles.css";
import { SVGAsset } from 'res';

/**
 * @function AlertsToggleView
 * @param {STRING} mainText - This is the main text that shows the title.
 * @param {STRING} subText - This is the smaller text that shows under the title.
 * @param {STRING} className - Additional classes to add to the AlertsToggleView.
 * @return {React.Component}
 * @exported true
 * @description This is the ToggleView used for only toggling on and off Alerts settings.
 * @example
 * <AlertsToggleView className={"added-class"} mainText={"Heading goes here"} subText={"Smaller sub-text goes here."} />
 */
export default function AlertsToggleView(props) {
  const mainText = props.mainText ?? "[Main Text]";
  const subText = props.subText ?? "[subText]";
  const className = props.className ?? "";
  const icon = props.icon ?? <SVGAsset id="RightChevronIcon" className="chevron-icon" />;

  return (
    <div className={className + " alerts-toggle-view"}>
      <BaseToggleView icon={icon} mainText={mainText} toggleBlock = {props.toggleBlock} subText={subText} onChange={ props.onChange } checked={ props.checked } />
    </div>
  );
}